import {
  getBackNotifiche,
  getFrontNotifiche,
  getGetBackNotificheQueryKey,
  getGetFrontNotificheQueryKey,
  useGetBackNotifiche,
  useGetFrontNotifiche,
  usePostFrontNotificheIdPresaVisione,
  usePutBackNotificheId,
} from '@framework/api-client';
import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useMemo,
} from 'react';

export interface INotificationsContext {
  /** Hook per ottenere le notifiche */
  useGetNotifications: typeof useGetFrontNotifiche | typeof useGetBackNotifiche;
  /** Hook per segnare una notifica come letta */
  useMarkAsRead:
    | typeof usePostFrontNotificheIdPresaVisione
    | typeof usePutBackNotificheId;
  /** Chiave della query per ottenere le notifiche */
  getGetNotificationsQueryKey:
    | typeof getGetFrontNotificheQueryKey
    | typeof getGetBackNotificheQueryKey;
  /** Funzione per ottenere le notifiche */
  getNotifications: typeof getFrontNotifiche | typeof getBackNotifiche;
}

export const NotificationsContext = createContext<INotificationsContext>(
  {} as INotificationsContext,
);

export function NotificationsContextProvider(
  props: PropsWithChildren<INotificationsContext>,
) {
  // const {} = props;

  const contextValue = useMemo(
    () => ({
      useGetNotifications: props.useGetNotifications,
      useMarkAsRead: props.useMarkAsRead,
      getGetNotificationsQueryKey: props.getGetNotificationsQueryKey,
      getNotifications: props.getNotifications,
    }),
    [
      props.useGetNotifications,
      props.useMarkAsRead,
      props.getGetNotificationsQueryKey,
      props.getNotifications,
    ],
  );

  return (
    <NotificationsContext.Provider value={contextValue}>
      {props.children}
    </NotificationsContext.Provider>
  );
}

/**
 * Hook per accedere al contesto delle comunicazioni
 */
export const useNotificationsContext = () => {
  return useContext(NotificationsContext);
};
